import isGraphqlId from 'utils/shopify/is-graphql-id';

export default (id: string | number, type: string) => {
  if (isGraphqlId(id)) {
    return id.toString();
  }

  return `gid://shopify/${type}/${id}`;
};
